export default {
    producao: true,
    nomeAmbiente: "Produção",
    URL_API_PORTAL: "https://apiportal.rncloud.com.br/api/",
    URL_API_SGTWEB: "https://apirelatorios.rncloud.com.br/api",
    URL_API_SGTWEB_KUBE: "https://apisgt.rncloud.com.br/api",
    CAPTCHA_KEY: "6LfBpKIZAAAAADz-xlwg6fqKvaHptykEWZSDeUXk",
    URL_NFSE: "http://www.nfse.trimapservicos.com.br/portal/acessocontribuinte.aspx",
    URL_VALIDADOR: "http://www.validar.servicostrimap.com.br"
};